<template>
  <div>
    <asn-query v-show="activeKey===1" ref="list" :orderStatus="orderStatus" :storers="storers" @add="add" @getDetail="getDetail"/>
    <asn-edit v-show="activeKey===2" ref="detail" :storers="storers" @back="back"/>
  </div>
</template>

<script>
import AsnQuery from '@/views/inbound/asn/AsnQuery'
import AsnEdit from '@/views/inbound/asn/AsnEdit'
import { findAll, findEnum } from '@/api/Api'
import SaleOrderDetail from '@/views/outbound/sale_order_make/SaleOrderDetail.vue'
import SaleOrderList from '@/views/outbound/sale_order_make/SaleOrderList.vue'

export default {
  name: 'Asn',
  components: {
    SaleOrderList, SaleOrderDetail,
    AsnEdit,
    AsnQuery
  },
  props: {
    'queryParam': {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      storers: []
    }
  },
  created() {
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatus = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storers = res.result.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.fetchOrderById(row.order.id)
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.init()
      this.$refs.detail.add()
    }
  }
}
</script>